import type { ReactNode } from 'react'

/** Labeled wrapper for a single filter control in the Filters sub-view. */
export function FilterField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className='ramp-filter-field'>
      <div className='ramp-filter-label'>{label}</div>
      {children}
    </div>
  )
}
